import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_updateHeroWidget, ParamsType, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_updateHeroWidget';

export type HeroWidgetModelType = Response200Type;

const decode = (status: number, data: ResponseType): HeroWidgetModelType => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface HeroWidgetTypeSubmitType {
    data: ParamsType['body'],
    id: number
}

export const put_update_hero_widget = {
    browser: {
        params: (params: HeroWidgetTypeSubmitType): ParamsFetchType<HeroWidgetTypeSubmitType> => {
            return {
                type: MethodType.PUT,
                url: '/api-web/update_hero_widget',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.PUT,
        urlBrowser: '/api-web/update_hero_widget',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<HeroWidgetTypeSubmitType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const response = await openapi_website_cms_updateHeroWidget(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            id: params.req.body.id,
            body: params.req.body.data
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
